import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Tooltip-root_2BPKk",
  "fade": "Tooltip-fade_14aMV",
  "appear-top": "Tooltip-appear-top_2MSbh",
  "appear-left": "Tooltip-appear-left_Bf1rI",
  "appear-bottom": "Tooltip-appear-bottom_2m580",
  "appear-right": "Tooltip-appear-right_fRV3b"
};
function Tooltip({
  id,
  arrow,
  children,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Base, {
    id: id,
    role: "tooltip",
    padding: "xsmall",
    borderRadius: "1x",
    color: "white",
    backgroundColor: "neutral-strong",
    className: clsx(styles.root, className),
    ...extraProps,
    children: [children, arrow]
  });
}
export { Tooltip };